import type { ComponentPropsWithoutRef, ElementType } from 'react';

export const DEFAULT_CARD_CLASSES =
  'rounded-2xl bg-black/20 backdrop-filter backdrop-blur-xl shadow-inner-glow shadow-inner-glow-black-md drop-shadow-glow-black-md';

interface DefaultCardProps extends ComponentPropsWithoutRef<'div'> {
  as?: ElementType;
  dataUi?: string;
}

/**
 * The standard Taratic content surface, matching the cards in Bots Config.
 * It intentionally supplies only the surface treatment; callers own spacing and layout.
 */
export default function DefaultCard({
  as: Component = 'div',
  className = '',
  dataUi = 'default-card',
  ...props
}: DefaultCardProps) {
  return <Component data-ui={dataUi} className={`${DEFAULT_CARD_CLASSES} ${className}`.trim()} {...props} />;
}
